import qs from 'qs';

import { API_URL } from './settings';

const getOptions = () => ({
	headers: new Headers({
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${localStorage.getItem('token')}`
	})
});

export const search = async (terms) => {
	const response = await fetch(`${API_URL}/search/live?q=${terms}`, getOptions());
	const { results } = await response.json();
	return results;
};

export const fetchDashboardStats = async () => {
	const response = await fetch(`${API_URL}/dashboard/stats`, getOptions());
	return await response.json();
};

export const fetchUserStats = async (id) => {
	const response = await fetch(`${API_URL}/stats/users/${id}`, getOptions());
	return await response.json();
};

export const fetchUsersLeavesStats = async (data) => {
	const query = data ? `?${qs.stringify(data, { arrayFormat: 'comma', encode: false, skipNulls: true })}` : '';
	const response = await fetch(`${API_URL}/stats/users/leaves${query}`, getOptions());
	return await response.json();
};

export const fetchUserLeavesStats = async (id, data) => {
	const query = data ? `?${qs.stringify(data, { arrayFormat: 'comma', encode: false, skipNulls: true })}` : '';
	const response = await fetch(`${API_URL}/stats/users/${id}/leaves${query}`, getOptions());
	return await response.json();
};

/* Account */
export const getAccount = async () => {
	const response = await fetch(`${API_URL}/account`, getOptions());
	return await response.json();
};

export const updateAccount = async (data) => {
	const response = await fetch(`${API_URL}/account`, { ...getOptions(), method: 'PUT', body: data });
	return await response.json();
};

export const forgotPassword = async (data) => {
	const response = await fetch(`${API_URL}/account/forget_password`, { method: 'POST', body: data });
	return await response.json();
};

export const resetPassword = async (data) => {
	const response = await fetch(`${API_URL}/account/reset_password`, { method: 'POST', body: data });
	return await response.json();
};

/* Leave */
export const markAcceptedLeave = async (id, data) => {
	const response = await fetch(`${API_URL}/leaves/${id}/mark_accepted`, { ...getOptions(), method: 'POST', body: data });
	return await response.json();
};

export const markRefusedLeave = async (id, data) => {
	const response = await fetch(`${API_URL}/leaves/${id}/mark_refused`, { ...getOptions(), method: 'POST', body: data });
	return await response.json();
};

/* Time entries */
export const fetchTimeEntriesStats = async (data) => {
	const query = data ? `?${qs.stringify(data, { arrayFormat: 'comma', encode: false, skipNulls: true })}` : '';
	const response = await fetch(`${API_URL}/stats/time_entries${query}`, getOptions());
	return await response.json();
};

export const fetchTimeEntryTypes = async (data) => {
	const query = data ? `?${qs.stringify(data, { arrayFormat: 'comma', encode: false, skipNulls: true })}` : '';
	const response = await fetch(`${API_URL}/time_entry_types${query}`, getOptions());
	return await response.json();
};

/* Projects */
export const fetchProjects = async (data) => {
	const query = data ? `?${qs.stringify(data, { arrayFormat: 'comma', encode: false, skipNulls: true })}` : '';
	const response = await fetch(`${API_URL}/projects${query}`, getOptions());
	return await response.json();
};

/* Weeklies */
export const fetchWeeklies = async (data) => {
	const query = data ? `?${qs.stringify(data, { arrayFormat: 'comma', encode: false, skipNulls: true })}` : '';
	const response = await fetch(`${API_URL}/weeklies${query}`, getOptions());
	return await response.json();
};

/* Suggestions */
export const addSuggestionComment = async (id, data) => {
	const response = await fetch(`${API_URL}/suggestions/${id}/comments`, { ...getOptions(), method: 'POST', body: data });
	return await response.json();
};

export const updateSuggestionComment = async (id, data) => {
	const response = await fetch(`${API_URL}/suggestions/comments/${id}`, { ...getOptions(), method: 'PUT', body: data });
	return await response.json();
};

export const downvoteSuggestion = async (id, data) => {
	const response = await fetch(`${API_URL}/suggestions/${id}/downvote`, { ...getOptions(), method: 'POST', body: data });
	return await response.json();
};

export const upvoteSuggestion = async (id, data) => {
	const response = await fetch(`${API_URL}/suggestions/${id}/upvote`, { ...getOptions(), method: 'POST', body: data });
	return await response.json();
};

export const markAcceptedSuggestion = async (id) => {
	const response = await fetch(`${API_URL}/suggestions/${id}/mark_accepted`, { ...getOptions(), method: 'POST' });
	return await response.json();
};

export const markRefusedSuggestion = async (id) => {
	const response = await fetch(`${API_URL}/suggestions/${id}/mark_refused`, { ...getOptions(), method: 'POST' });
	return await response.json();
};

/* Articles */
export const publish = async (id) => {
	const response = await fetch(`${API_URL}/articles/${id}/publish`, { ...getOptions(), method: 'POST' });
	return response.json();
};

export const unpublish = async (id) => {
	const response = await fetch(`${API_URL}/articles/${id}/unpublish`, { ...getOptions(), method: 'POST' });
	return response.json();
};

/* Invoices */
export const sendInvoice = async (id, data) => {
	const response = await fetch(`${API_URL}/invoices/${id}/send`, { ...getOptions(), method: 'POST', body: data });
	return await response.json();
};

export const sendInvoiceEmail = async (id, data) => {
	const response = await fetch(`${API_URL}/invoices/${id}/send-email`, { ...getOptions(), method: 'POST', body: data });
	return await response.json();
};

export const sendInvoicePeppol = async (id) => {
	const response = await fetch(`${API_URL}/invoices/${id}/send-peppol`, { ...getOptions(), method: 'POST' });
	return await response.json();
};

export const reverseInvoice = async (id) => {
	const response = await fetch(`${API_URL}/invoices/${id}/reverse`, { ...getOptions(), method: 'POST' });
	return await response.json();
};

export const cloneInvoice = async (id) => {
	const response = await fetch(`${API_URL}/invoices/${id}/clone`, { ...getOptions(), method: 'POST' });
	return await response.json();
};

export const markPaidInvoice = async (id) => {
	const response = await fetch(`${API_URL}/invoices/${id}/mark_paid`, { ...getOptions(), method: 'POST' });
	return await response.json();
};

export const markUnPaidInvoice = async (id) => {
	const response = await fetch(`${API_URL}/invoices/${id}/mark_unpaid`, { ...getOptions(), method: 'POST' });
	return await response.json();
};

export const setInvoiceService = async (id, service) => {
	const response = await fetch(`${API_URL}/invoices/${id}/set_service`, {
		...getOptions(),
		method: 'POST',
		body: JSON.stringify({ service_type: service }),
	});
	return await response.json();
};

export const validateInvoiceUBL = async (id) => {
	const response = await fetch(`${API_URL}/invoices/${id}/validate-ubl`, getOptions());
	return await response.json();
};

/* Addresses */
export const checkAddressPeppol = async (id) => {
	const response = await fetch(`${API_URL}/addresses/${id}/check-peppol`, { ...getOptions(), method: 'POST' });
	return await response.json();
};

/* Costs */
export const fetchCostReport = async (data) => {
	const query = data ? `?${qs.stringify(data, { arrayFormat: 'comma', encode: false, skipNulls: true })}` : '';
	const response = await fetch(`${API_URL}/costs/report${query}`, getOptions());
	return await response.json();
};

/* Invoicing Dashboard */
export const fetchInvoicingReport = async (data) => {
	const query = data ? `?${qs.stringify(data, { arrayFormat: 'comma', encode: false, skipNulls: true })}` : '';
	const response = await fetch(`${API_URL}/dashboards/invoicing${query}`, getOptions());
	return await response.json();
};

/* Team Monthly Dashboard */
export const fetchTeamMonthlyReport = async () => {
	const response = await fetch(`${API_URL}/dashboards/team_monthly`, getOptions());
	return await response.json();
};

/* Campaigns */
export const addLeadToCampaign = async (campaignId, leadId) => {
	const response = await fetch(`${API_URL}/campaigns/${campaignId}/leads`, {
		...getOptions(),
		method: 'POST',
		body: JSON.stringify({ lead_id: leadId }),
	});
	return await response.json();
};

/* Tasks */
export const postActionTask = async (taskId, action) => {
	const response = await fetch(`${API_URL}/tasks/${taskId}/${action}`, { ...getOptions(), method: 'POST' });
	return await response.json();
};

/* AMA Assistant */
const amaHeaders = () => ({
	'Content-Type': 'application/json',
	'Authorization': `Bearer ${localStorage.getItem('token')}`,
});

export const listAmaConversations = async () => {
	const res = await fetch(`${API_URL}/ama/conversations`, { headers: amaHeaders() });
	if (!res.ok) throw new Error(`HTTP ${res.status}`);
	return await res.json();
};

export const getAmaConversation = async (id) => {
	const res = await fetch(`${API_URL}/ama/conversations/${id}`, { headers: amaHeaders() });
	if (!res.ok) throw new Error(`HTTP ${res.status}`);
	return await res.json();
};

export const renameAmaConversation = async (id, title) => {
	const res = await fetch(`${API_URL}/ama/conversations/${id}`, {
		method: 'PUT',
		headers: amaHeaders(),
		body: JSON.stringify({ title }),
	});
	if (!res.ok) throw new Error(`HTTP ${res.status}`);
	return await res.json();
};

export const deleteAmaConversation = async (id) => {
	const res = await fetch(`${API_URL}/ama/conversations/${id}`, {
		method: 'DELETE',
		headers: amaHeaders(),
	});
	if (!res.ok) throw new Error(`HTTP ${res.status}`);
	return await res.json();
};

export const streamAmaChat = async (messages, onEvent, signal, conversationId = null) => {
	const res = await fetch(`${API_URL}/ama/chat/stream`, {
		method: 'POST',
		headers: amaHeaders(),
		body: JSON.stringify({ messages, conversation_id: conversationId }),
		signal,
	});
	if (!res.ok) {
		throw new Error(`HTTP ${res.status}`);
	}
	const reader = res.body.getReader();
	const decoder = new TextDecoder();
	let buffer = '';
	while (true) {
		const { value, done } = await reader.read();
		if (done) break;
		buffer += decoder.decode(value, { stream: true });
		const frames = buffer.split('\n\n');
		buffer = frames.pop();
		for (const frame of frames) {
			if (!frame.startsWith('data: ')) continue;
			try {
				onEvent(JSON.parse(frame.slice(6)));
			} catch (e) {
				// ignore malformed frame
			}
		}
	}
};

/* External API */
/* Holidays */
export const fetchHolidays = async (year) => {
	const response = await fetch(`https://openholidaysapi.org/PublicHolidays?countryIsoCode=BE&validFrom=${year}-01-01&validTo=${year}-12-31`);
	const data = await response.json();
	return data.map(item => ({
		date: item.startDate,
		name: item.name
	}));
};

/* Reviews */
export const fetchReviewGrid = async (lang) => {
	const query = lang ? `?lang=${lang}` : '';
	const response = await fetch(`${API_URL}/review_grid${query}`, getOptions());
	return await response.json();
};

export const postReviewAction = async (id, action) => {
	const response = await fetch(`${API_URL}/reviews/${id}/${action}`, { ...getOptions(), method: 'POST' });
	const json = await response.json();
	if (!response.ok || json?.success === false) {
		throw new Error(json?.message || response.statusText);
	}
	return json;
};

export const putReviewActionPlan = async (id, actionPlan) => {
	const response = await fetch(`${API_URL}/reviews/${id}/action_plan`, {
		...getOptions(),
		method: 'PUT',
		body: JSON.stringify({ action_plan: actionPlan })
	});
	const json = await response.json();
	if (!response.ok || json?.success === false) {
		throw new Error(json?.message || response.statusText);
	}
	return json;
};

/* Focus */
const focusRequest = async (path, method = 'GET', body) => {
	const response = await fetch(`${API_URL}${path}`, {
		...getOptions(),
		method,
		...(body !== undefined ? { body: JSON.stringify(body) } : {})
	});
	const json = await response.json();
	if (!response.ok || json?.success === false) {
		throw new Error(json?.message || response.statusText);
	}
	return json;
};

export const fetchFocusBoard = () => focusRequest('/focus');
export const putFocusCard = (userId, data) => focusRequest(`/focus/${userId}`, 'PUT', data);
export const postFocusItem = (data) => focusRequest('/focus_items', 'POST', data);
export const putFocusItem = (id, data) => focusRequest(`/focus_items/${id}`, 'PUT', data);
export const deleteFocusItem = (id) => focusRequest(`/focus_items/${id}`, 'DELETE');
export const reorderFocusItems = (userId, itemIds) => focusRequest('/focus_items/reorder', 'POST', { user_id: userId, item_ids: itemIds });
export const postFocusCompute = (userId) => focusRequest('/focus/compute', 'POST', userId ? { user_id: userId } : {});
export const fetchFocusHistory = (userId, days = 90) => focusRequest(`/focus/${userId}/history?days=${days}`);
export const fetchFocusCard = (userId) => focusRequest(`/focus/${userId}`);
export const fetchFocusTimesheet = (userId, weeks = 6) => focusRequest(`/focus/${userId}/timesheet?weeks=${weeks}`);

/* API tokens */
export const fetchApiTokens = async () => {
	const response = await fetch(`${API_URL}/account/tokens`, getOptions());
	return await response.json();
};

export const createApiToken = async (data) => {
	const response = await fetch(`${API_URL}/account/tokens`, { ...getOptions(), method: 'POST', body: JSON.stringify(data) });
	return await response.json();
};

export const revokeApiToken = async (id) => {
	const response = await fetch(`${API_URL}/account/tokens/${id}`, { ...getOptions(), method: 'DELETE' });
	return await response.json();
};
